import MenuItemList, { MenuItemListProps } from './MenuItemList';

export type { MenuItemListProps };
export default MenuItemList;
